import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

const SidebarContext = createContext(null);

const STORAGE_KEY = 'sidebar_collapsed';

export const SidebarProvider = ({ children }) => {
    const isMobile = useMediaQuery('(max-width:768px)');
    const [collapsed, setCollapsed] = useState(() => {
        try {
            return localStorage.getItem(STORAGE_KEY) === 'true';
        } catch {
            return false;
        }
    });
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        try {
            localStorage.setItem(STORAGE_KEY, String(collapsed));
        } catch { /* ignore */ }
    }, [collapsed]);

    const toggleCollapsed = useCallback(() => setCollapsed(prev => !prev), []);
    const toggleMobile = useCallback(() => setMobileOpen(prev => !prev), []);
    const closeMobile = useCallback(() => setMobileOpen(false), []);

    return (
        <SidebarContext.Provider value={{ collapsed, mobileOpen, isMobile, toggleCollapsed, toggleMobile, closeMobile }}>
            {children}
        </SidebarContext.Provider>
    );
};

export const useSidebar = () => useContext(SidebarContext);
